import type { RouteRecordRaw } from 'vue-router'

export const kitchenRoutes: RouteRecordRaw[] = [
  {
    path: '/kitchen',
    children: [
      {
        path: 'orders',
        name: 'KitchenOrders',
        component: () => import('@/modules/kitchen/views/KitchenOrdersScreen.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'list',
        name: 'OrdersList',
        component: () => import('@/modules/kitchen/views/OrdersListScreen.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
]